import { render, staticRenderFns } from "./OrganizationOrder.vue?vue&type=template&id=4fd78000&scoped=true&"
import script from "./OrganizationOrder.vue?vue&type=script&lang=js&"
export * from "./OrganizationOrder.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationOrder.vue?vue&type=style&index=0&id=4fd78000&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd78000",
  null
  
)

export default component.exports